<router-outlet *ngIf="activatedRouteRef?.children.length > 0"></router-outlet>
<!-- <div class="body-container container-fluid">
  <div class="cards d-flex flex-wrap gap-2" *ngIf="routerRef.url === '/home'">
    <div *ngFor="let menu of menuList" class="s-min-w-80">
      <app-z-card
        role="button"
        [routerLink]="'home/' + menu.path"
        [title]="menu.title | transloco"
        [icon]="menu.icon"
        iconBackground="green"
        [showValue]="false"
      >
      </app-z-card>
    </div>
  </div>
</div> -->
